import { render, staticRenderFns } from "./UpdateABlog.vue?vue&type=template&id=c4be126a"
import script from "./UpdateABlog.vue?vue&type=script&lang=js"
export * from "./UpdateABlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports